// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDNGURj7B7fdURgsO2rBFRJhr_jPHTklZc",
  authDomain: "flashcard-world-program.firebaseapp.com",
  databaseURL: "https://flashcard-world-program-default-rtdb.firebaseio.com/",
  projectId: "flashcard-world-program",
  storageBucket: "flashcard-world-program.firebasestorage.app",
  messagingSenderId: "625883505785",
  appId: "1:625883505785:web:70cd705fb9738ffe64e0a8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const database = getDatabase(app);

export {
  app,
  analytics,
  database
};
